/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { UpsellDeprecated } from 'core/offers/entities';

export const updateSelectedUpsell = createAction<UpsellDeprecated>('offers/UPDATE_SELECTED_UPSELL');
